module.exports = __webpack_public_path__ + "static/media/step-by-step-screens.d479fde4.png";